import User, { normalizeRole, normalizeUser, Role, UserRequest } from "@dto/Users";
import { get, post } from "./utils";
import { isCompozzError } from "@dto/CompozzError";
import { BASE_URL } from "./constants";

export const USER_FORMULA = "${USER}";
export const CURRENT_USER = "currentUser";

// Rights are normalised at the loading boundary (legacy access values become a
// level and an options list), so the rest of the app only sees the new shape.

export const fetchUsers = async () => {
    const response = await get<User[]>(`${BASE_URL}/admin/users`);
    if (isCompozzError(response)) {
        console.error(response);
        return [];
    }
    const users = response || []
    return users.map(normalizeUser);
}

export const fetchUser = async (username: string): Promise<User | undefined> => {
    const userRequest: UserRequest = {
        username: username,
        userKey: ""
    }
    const response = await post<User>(`${BASE_URL}/admin/users/search`, userRequest);
    if (isCompozzError(response)) {
        console.error(response);
        return undefined;
    }
    const user = response || undefined
    return user ? normalizeUser(user) : undefined;
}

export const fetchRole = async (wsKey: string): Promise<Role | null> => {
    const response = await get<Role>(`${BASE_URL}/auth/users/workspaces/${wsKey}/role`);
    if (isCompozzError(response)) {
        console.error(response);
        return null;
    }
    const userRole = response || null;
    return userRole ? normalizeRole(userRole) : null;
}